module.exports = __webpack_public_path__ + "static/media/zaptalent-office.d00d6d8b.png";